import { render, staticRenderFns } from "./DetailedAccounts.vue?vue&type=template&id=283e79a2&"
import script from "./DetailedAccounts.vue?vue&type=script&lang=js&"
export * from "./DetailedAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports